<template>
    <div :class="[
        'card-indicator',
        type
    ]">
        <div v-if="type === 'type-3'" class="card-indicator--header">
            <el-tag size="small" :type="typeIconBox" plain circle>
                <i v-if="icon" :class="icon"></i>
            </el-tag>
            <h6 class="mb-0">{{ title }}</h6>
        </div>

        <div v-else class="card-indicator--header">
            <h6 class="mb-0 text-black-50">{{ title }}</h6>
            <el-tag :size="type == 'type-min' ? 'mini' : 'small'" :type="typeIconBox" plain class="rounded-circle" :style="{
                minWidth: '20px',
                minHeight: '20px'
            }">
                <i v-if="icon" :class="icon"></i>
            </el-tag>
        </div>

        <div class="card-indicator--description">
            <slot name="description">

            </slot>
        </div>

        <div class="card-indicator--footer">
            <h5 class="mb-0"><strong>{{ value }}</strong></h5>      
            <slot name="extra"></slot>
        </div>
    </div>
</template>

<script>
import { head } from 'lodash';

    export default {
        name: 'card-indicator',
        props: {
            title: {
                type: String,
                default: null,
            },
            description: {
                type: String,
                default: null,
            },
            value: {
                type: [String, Number],
                default: null,
            },
            type: {
                type: String,
                default: null,
            },
            icon: {
                type: String,
                default: null,
            },
            typeIconBox: {
                type: String,
                default: 'primary'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-indicator {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
        padding: 16px;
        background-color: #FFF;
        border: 1px solid #dedede;
        border-radius: 10px;

        box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 5px 0px;

        &.destach {
            background-color: #f56c6c13;
        }

        &.type-min {
            height: 80px;
        }

        >.card-indicator--header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        >.card-indicator--footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &.type-2 {
            background-color: #F9F9F9;
            border: none;
            box-shadow: rgba(0,0,0,0.15) 0px 0.1px 5px 0px;
        }

        &.type-3 {
            gap: 17px;

            .card-indicator--header {
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;

                h6 {
                    font-weight: bold;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/Card/CardIndicator.vue